module.exports = __webpack_public_path__ + "static/friends-0b528e631143d22faf2805b95a176abc.png";